export type ParentBonusRequest = { amount: number; note: string; requestId: string };

// Keep the same request id for this form; never automatically retry an uncertain write.
export function masteryBonusSubmission(save: (request: ParentBonusRequest) => Promise<{ ok: boolean }>, requestId = crypto.randomUUID()) {
  let attempted = false;
  return async (amount: number, rawNote: string) => {
    const note = rawNote.trim();
    if (!Number.isInteger(amount) || amount < 1 || amount > 100000) throw new Error("Choose a whole-number bonus from 1 to 100000.");
    if (note.length < 2 || note.length > 240) throw new Error("Describe the bonus in 2–240 characters.");
    if (attempted) return null;
    attempted = true;
    const result = await save({ amount, note, requestId });
    if (!result.ok) throw new Error("Bonus was not confirmed.");
    return { bonus: amount };
  };
}

export function parentBonusAvailable(settings: { parentBonusEnabled?: boolean }) {
  return settings.parentBonusEnabled === true;
}
